import { Pipe, PipeTransform,SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import {Utils} from './_util/utils';
import { isNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
@Pipe({
  name: 'highlighter'
})
export class HighlighterPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, args: any,caseOn:boolean, allMatches:string, type:string): unknown {//console.log(value, args,caseOn, allMatches, type)
  if(!value) return value;
    if(!isNaN(parseFloat(value))) return value;
  if(allMatches&&allMatches.length>0){
      /*let words=allMatches[0]
      for(let key of allMatches.slice(0)){
        words+='|'+key;*/
      //console.log(words)
      const res = new RegExp("\\b("+allMatches+"(?=(?:[^><]*<[^<>]*>)*[^><]*$))\\b", 'gm');
      let result1=value.match(res);
      if(result1&&result1.length>0){
        if(type){
          value = value.replace(res, `<span style="text-decoration: underline;text-decoration-color: red;text-decoration-thickness: 2px;">$1</span>`); 
        }else{
        
          const newText = value.replace(res, (match: string) => {
            return `<span style="text-decoration: underline;text-decoration-color: red;text-decoration-thickness: 2px;">${match}</span>`;
          });//console.log(newText)
         const sanitzed = this.sanitizer.bypassSecurityTrustHtml(newText);
         value=sanitzed;
        
        }
        
      }
    }
    if(!args||!value) return value;
    let replaceRule='igm';
    if(caseOn){
      replaceRule='gm'
    }
    if(type==='full'){
      //const re = new RegExp("\\b("+args+"\\b)", replaceRule);
      const re = new RegExp("\\b("+args+"(?=(?:[^><]*<[^<>]*>)*[^><]*$))\\b", replaceRule);
      let result = value.match(re);
			if(result&&result.length>0){
        let id=Utils.uniqueIdGenerator();
        
        value = value.replace(re, `<mark id=`+id+` style="background-color: #ffa64d">$1</mark>`);
        //const sanitzed = this.sanitizer.bypassSecurityTrustHtml(newText);
       /* const sanitzed = this.sanitizer.sanitize(
          SecurityContext.HTML,
          newText
        )
        value = sanitzed;*/
      }
      
    }else{
      //const re = new RegExp("\\b("+args+"\\b)", replaceRule);
      const re = new RegExp("\\b("+args+"(?=(?:[^><]*<[^<>]*>)*[^><]*$))\\b", replaceRule);
      /*const regex = new RegExp(this.searchTerm,this.caseSensitive ? "g" : "gi");*/
      let result = value.match(re);
			if(result&&result.length>0){
        let id=Utils.uniqueIdGenerator();
       
        const newText = value.replace(re, (match: string) => {
          return `<mark  id=`+id+` style="background-color: #ffa64d">${match}</mark>`;
        });//console.log(newText)
       const sanitzed = this.sanitizer.bypassSecurityTrustHtml(newText)
        /*const sanitzed = this.sanitizer.sanitize(
          SecurityContext.HTML,
          newText
      );
      value = sanitzed;console.log(value)*/
      value=sanitzed; //console.log(value)
      }
      /*const re = new RegExp(args, 'igm');
      value= value.replace(re, '<span class="background-color: #ffa64d">$&</span>');
      value="<span>"+value+"</span>";*/
    }
    //console.log(value)
      return value;
  }

}
